(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow-custom"] && !Shopify.designMode) return;
  try {
    
  function initializeCustomSlideshows(root = document) {
    if (typeof window.Swiper !== 'function') return;

    root.querySelectorAll('.kvSwiper').forEach((container) => {
      if (container.swiper) return;

      new window.Swiper(container, {
        loop: true,
        effect: 'slide',
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  }

  function destroyCustomSlideshows(root) {
    root.querySelectorAll('.kvSwiper').forEach((container) => {
      if (container.swiper && !container.swiper.destroyed) {
        container.swiper.destroy(true, true);
      }
    });
  }

  initializeCustomSlideshows();

  document.addEventListener('shopify:section:load', (event) => {
    initializeCustomSlideshows(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyCustomSlideshows(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
